import type { ExtensionFeatureStateType } from '@/modules/creator-settings/state/SettingsProvider'

export interface VisibilityItem {
  id: number
  title: string
  description: string
  toast: Record<'visible' | 'hidden', string>
  type: ExtensionFeatureStateType
}

export const visibilityItems: Array<VisibilityItem> = [
  {
    type: 'showScripts',
    id: 1,
    title: 'Show Scripts',
    description:
      "Use the scripts you've created to quickly send preset messages",
    toast: {
      visible: 'Scripts are now visible',
      hidden: 'Scripts are now hidden',
    },
  },
  {
    type: 'showFanDetails',
    id: 2,
    title: 'Show Fan Details',
    description: "Shows the fans' details while chatting to them",
    toast: {
      visible: 'Fan details are now visible',
      hidden: 'Fan details are now hidden',
    },
  },
  {
    type: 'showGlobalInfo',
    id: 3,
    title: 'Show Global Info',
    description: 'Shows the timezones and your online fans',
    toast: {
      visible: 'Global info is now visible',
      hidden: 'Global info is now hidden',
    },
  },
  {
    type: 'showFanSpending',
    id: 4,
    title: 'Show Fan Spending',
    description: "Shows the fans' total spend in the inbox",
    toast: {
      visible: 'Fan spending is now visible',
      hidden: 'Fan spending is now hidden',
    },
  },
  {
    type: 'showBiggerVault',
    id: 5,
    title: 'Bigger Vault',
    description: 'Makes the vault on OnlyFans appear bigger',
    toast: {
      visible: 'Bigger Vault is now active',
      hidden: 'Bigger Vault is now disabled',
    },
  },
]
